/* tslint:disable */
/* eslint-disable */
/**
 * Mercatus Portal
 * Mercatus Portal
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@gomercatus.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { AttachmentDeleteResponse } from '../model';
// @ts-ignore
import { AttachmentUploadResponse } from '../model';
// @ts-ignore
import { BulkChangeChunkRequest } from '../model';
// @ts-ignore
import { BulkChangeChunkResponse } from '../model';
// @ts-ignore
import { EntityIdReservationResponse } from '../model';
// @ts-ignore
import { RootInfoListItem } from '../model';
/**
 * IngestionApi - axios parameter creator
 * @export
 */
export const IngestionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Creates an entity id reservation for attachment uploads, bound to the caller\'s organization and the requested Entity Type. Use its UUID when creating an Entity in the same organization with the same entityTypeId.
         * @summary Creates an entity id reservation.
         * @param {number} entityTypeId Entity Type for the Entity that will use the reservation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityReservation: async (entityTypeId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityTypeId' is not null or undefined
            assertParamExists('createEntityReservation', 'entityTypeId', entityTypeId)
            const localVarPath = `/ingestion/entityReservations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (entityTypeId !== undefined) {
                localVarQueryParameter['entityTypeId'] = entityTypeId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes an attachment file.
         * @summary Deletes an attachment file.
         * @param {number} attachmentId attachment id
         * @param {number} entityId entity id
         * @param {number} assumptionId assumption id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAttachment: async (attachmentId: number, entityId: number, assumptionId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'attachmentId' is not null or undefined
            assertParamExists('deleteAttachment', 'attachmentId', attachmentId)
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('deleteAttachment', 'entityId', entityId)
            // verify required parameter 'assumptionId' is not null or undefined
            assertParamExists('deleteAttachment', 'assumptionId', assumptionId)
            const localVarPath = `/ingestion/attachments/{attachmentId}`
                .replace(`{${"attachmentId"}}`, encodeURIComponent(String(attachmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }

            if (assumptionId !== undefined) {
                localVarQueryParameter['assumptionId'] = assumptionId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get state.
         * @summary Gets current info list state.
         * @param {number} entityId bulk entity id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBulkInfoList: async (entityId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('getBulkInfoList', 'entityId', entityId)
            const localVarPath = `/ingestion/bulk/entities/{entityId}/infoList`
                .replace(`{${"entityId"}}`, encodeURIComponent(String(entityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates a chunk.
         * @summary Updates a chunk.
         * @param {BulkChangeChunkRequest} bulkChangeChunkRequest Bulk change request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateChunk: async (bulkChangeChunkRequest: BulkChangeChunkRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkChangeChunkRequest' is not null or undefined
            assertParamExists('updateChunk', 'bulkChangeChunkRequest', bulkChangeChunkRequest)
            const localVarPath = `/ingestion/updateChunk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkChangeChunkRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Uploads an attachment file.
         * @summary Uploads an attachment file.
         * @param {string} entityId entity id or reservation uuid
         * @param {number} assumptionId assumption id
         * @param {any} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadAttachment: async (entityId: string, assumptionId: number, file: any, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('uploadAttachment', 'entityId', entityId)
            // verify required parameter 'assumptionId' is not null or undefined
            assertParamExists('uploadAttachment', 'assumptionId', assumptionId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadAttachment', 'file', file)
            const localVarPath = `/ingestion/attachments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }

            if (assumptionId !== undefined) {
                localVarQueryParameter['assumptionId'] = assumptionId;
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * IngestionApi - functional programming interface
 * @export
 */
export const IngestionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = IngestionApiAxiosParamCreator(configuration)
    return {
        /**
         * Creates an entity id reservation for attachment uploads, bound to the caller\'s organization and the requested Entity Type. Use its UUID when creating an Entity in the same organization with the same entityTypeId.
         * @summary Creates an entity id reservation.
         * @param {number} entityTypeId Entity Type for the Entity that will use the reservation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEntityReservation(entityTypeId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityIdReservationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEntityReservation(entityTypeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Deletes an attachment file.
         * @summary Deletes an attachment file.
         * @param {number} attachmentId attachment id
         * @param {number} entityId entity id
         * @param {number} assumptionId assumption id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAttachment(attachmentId: number, entityId: number, assumptionId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AttachmentDeleteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAttachment(attachmentId, entityId, assumptionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get state.
         * @summary Gets current info list state.
         * @param {number} entityId bulk entity id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBulkInfoList(entityId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RootInfoListItem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBulkInfoList(entityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Updates a chunk.
         * @summary Updates a chunk.
         * @param {BulkChangeChunkRequest} bulkChangeChunkRequest Bulk change request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateChunk(bulkChangeChunkRequest: BulkChangeChunkRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkChangeChunkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateChunk(bulkChangeChunkRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Uploads an attachment file.
         * @summary Uploads an attachment file.
         * @param {string} entityId entity id or reservation uuid
         * @param {number} assumptionId assumption id
         * @param {any} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadAttachment(entityId: string, assumptionId: number, file: any, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AttachmentUploadResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadAttachment(entityId, assumptionId, file, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * IngestionApi - factory interface
 * @export
 */
export const IngestionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = IngestionApiFp(configuration)
    return {
        /**
         * Creates an entity id reservation for attachment uploads, bound to the caller\'s organization and the requested Entity Type. Use its UUID when creating an Entity in the same organization with the same entityTypeId.
         * @summary Creates an entity id reservation.
         * @param {number} entityTypeId Entity Type for the Entity that will use the reservation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityReservation(entityTypeId: number, options?: any): AxiosPromise<EntityIdReservationResponse> {
            return localVarFp.createEntityReservation(entityTypeId, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes an attachment file.
         * @summary Deletes an attachment file.
         * @param {number} attachmentId attachment id
         * @param {number} entityId entity id
         * @param {number} assumptionId assumption id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAttachment(attachmentId: number, entityId: number, assumptionId: number, options?: any): AxiosPromise<AttachmentDeleteResponse> {
            return localVarFp.deleteAttachment(attachmentId, entityId, assumptionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get state.
         * @summary Gets current info list state.
         * @param {number} entityId bulk entity id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBulkInfoList(entityId: number, options?: any): AxiosPromise<RootInfoListItem> {
            return localVarFp.getBulkInfoList(entityId, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates a chunk.
         * @summary Updates a chunk.
         * @param {BulkChangeChunkRequest} bulkChangeChunkRequest Bulk change request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateChunk(bulkChangeChunkRequest: BulkChangeChunkRequest, options?: any): AxiosPromise<BulkChangeChunkResponse> {
            return localVarFp.updateChunk(bulkChangeChunkRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Uploads an attachment file.
         * @summary Uploads an attachment file.
         * @param {string} entityId entity id or reservation uuid
         * @param {number} assumptionId assumption id
         * @param {any} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadAttachment(entityId: string, assumptionId: number, file: any, options?: any): AxiosPromise<AttachmentUploadResponse> {
            return localVarFp.uploadAttachment(entityId, assumptionId, file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * IngestionApi - object-oriented interface
 * @export
 * @class IngestionApi
 * @extends {BaseAPI}
 */
export class IngestionApi extends BaseAPI {
    /**
     * Creates an entity id reservation for attachment uploads, bound to the caller\'s organization and the requested Entity Type. Use its UUID when creating an Entity in the same organization with the same entityTypeId.
     * @summary Creates an entity id reservation.
     * @param {number} entityTypeId Entity Type for the Entity that will use the reservation.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IngestionApi
     */
    public createEntityReservation(entityTypeId: number, options?: any) {
        return IngestionApiFp(this.configuration).createEntityReservation(entityTypeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes an attachment file.
     * @summary Deletes an attachment file.
     * @param {number} attachmentId attachment id
     * @param {number} entityId entity id
     * @param {number} assumptionId assumption id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IngestionApi
     */
    public deleteAttachment(attachmentId: number, entityId: number, assumptionId: number, options?: any) {
        return IngestionApiFp(this.configuration).deleteAttachment(attachmentId, entityId, assumptionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get state.
     * @summary Gets current info list state.
     * @param {number} entityId bulk entity id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IngestionApi
     */
    public getBulkInfoList(entityId: number, options?: any) {
        return IngestionApiFp(this.configuration).getBulkInfoList(entityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates a chunk.
     * @summary Updates a chunk.
     * @param {BulkChangeChunkRequest} bulkChangeChunkRequest Bulk change request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IngestionApi
     */
    public updateChunk(bulkChangeChunkRequest: BulkChangeChunkRequest, options?: any) {
        return IngestionApiFp(this.configuration).updateChunk(bulkChangeChunkRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Uploads an attachment file.
     * @summary Uploads an attachment file.
     * @param {string} entityId entity id or reservation uuid
     * @param {number} assumptionId assumption id
     * @param {any} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IngestionApi
     */
    public uploadAttachment(entityId: string, assumptionId: number, file: any, options?: any) {
        return IngestionApiFp(this.configuration).uploadAttachment(entityId, assumptionId, file, options).then((request) => request(this.axios, this.basePath));
    }
}
